export const DEFAULT_LOCALE = 'en-US'
export const SPANISH_LOCALE = 'es-419'
export const TURKISH_LOCALE = 'tr-TR'
export const SUPPORTED_LOCALES = [DEFAULT_LOCALE, SPANISH_LOCALE, TURKISH_LOCALE]

export const translations = {
	'en-US': {
		metaTitle: 'Flight 67',
		metaDescription:
			'Investigate the Flight 67 passenger manifest and see what an AI system can infer from passenger data.',
		languageLabel: 'Language',
		english: 'English',
		spanish: 'Español',
		turkish: 'Türkçe',
		classroomActivity: 'Classroom activity',
		flight67: 'Flight 67',
		passengerManifest: 'Passenger Manifest',
		introParagraph1:
			'You are seated on Flight 67, next to your friend Alex. Open any passenger file from the seat map, then turn on data sources to see what an investigator, and an AI model, can learn.',
		introParagraph2:
			'Watch how the picture changes as more data is added. Does the system’s “likely suspect” score always point to the right person?',
		instruction1: 'Click a seat to open that passenger’s file.',
		instruction2: 'Use the data access toggles to reveal biometrics, phone data, and AI analysis.',
		instruction3: 'Compare what you can see with the AI suspect score, including Alex’s.',
		openManifest: 'Open the manifest',
		manifestTitle: 'Flight 67 passenger manifest',
		confidential: 'Confidential',
		backToInstructions: 'Back to instructions',
		dataAccess: 'Data access',
		biometrics: 'Biometrics',
		on: 'On',
		off: 'Off',
		cellPhoneData: 'Cell phone data',
		digitalProfile: 'Digital profile',
		websites: 'Websites',
		texts: 'Texts',
		purchases: 'Purchases',
		aiAnalysis: 'AI analysis',
		facialRec: 'Facial rec',
		suspectScore: 'Suspect score',
		alexMercer: 'Alex Mercer',
		seatMap: 'Seat map',
		selectedPassenger: 'Selected passenger',
		yourSeatAria: 'Your seat, 13A',
		seatAria: 'Seat {seat}',
		alexSeatAria: 'Seat {seat}, Alex Mercer',
		you: 'YOU',
		selectPassenger: 'Select a passenger',
		clickSeatForData: 'Click a seat to view available data.',
		javascriptRequired: 'This classroom activity needs JavaScript to open the passenger manifest.',
		yourFriend: 'Your friend',
		seat: 'Seat',
		hometown: 'Hometown',
		passport: 'Passport',
		aiLikelySuspectScore: 'AI likely suspect score',
		facialRecognitionConfidence: 'Facial recognition confidence',
		sex: 'Sex',
		age: 'Age',
		height: 'Height',
		eyeColor: 'Eye color',
		hairColor: 'Hair color',
		digitalFootprint: 'Digital footprint',
		emailAddresses: 'Email addresses',
		noneFound: 'None found',
		socialMedia: 'Social media',
		recentPurchases: 'Recent purchases',
		noData: 'No data',
		lastThreeTextMessages: 'Last 3 text messages',
		message: 'Message',
		lastThreeWebsitesVisited: 'Last 3 websites visited',
		male: 'Male',
		female: 'Female',
	},
	'es-419': {
		metaTitle: 'Vuelo 67',
		metaDescription:
			'Investiga el manifiesto de pasajeros del Vuelo 67 y descubre qué puede inferir un sistema de IA a partir de los datos de los pasajeros.',
		languageLabel: 'Idioma',
		english: 'English',
		spanish: 'Español',
		turkish: 'Türkçe',
		classroomActivity: 'Actividad para el aula',
		flight67: 'Vuelo 67',
		passengerManifest: 'Manifiesto de pasajeros',
		introParagraph1:
			'Estás a bordo del Vuelo 67, sentado junto a tu amigo Alex. Abre el expediente de cualquier pasajero en el mapa de asientos y luego activa distintas fuentes de datos para descubrir qué pueden averiguar un investigador y un modelo de IA.',
		introParagraph2:
			'Observa cómo cambia la situación a medida que se agregan más datos. ¿El puntaje de “probable sospechoso” del sistema siempre señala a la persona correcta?',
		instruction1: 'Haz clic en un asiento para abrir el expediente de ese pasajero.',
		instruction2:
			'Usa los controles de acceso a datos para revelar información biométrica, datos del teléfono y análisis de IA.',
		instruction3: 'Compara lo que puedes ver con el puntaje de sospecha de la IA, incluido el de Alex.',
		openManifest: 'Abrir el manifiesto',
		manifestTitle: 'Manifiesto de pasajeros del Vuelo 67',
		confidential: 'Confidencial',
		backToInstructions: 'Volver a las instrucciones',
		dataAccess: 'Acceso a datos',
		biometrics: 'Datos biométricos',
		on: 'Sí',
		off: 'No',
		cellPhoneData: 'Datos del teléfono',
		digitalProfile: 'Perfil digital',
		websites: 'Sitios web',
		texts: 'Mensajes',
		purchases: 'Compras',
		aiAnalysis: 'Análisis de IA',
		facialRec: 'Reconocimiento facial',
		suspectScore: 'Puntaje de sospecha',
		alexMercer: 'Alex Mercer',
		seatMap: 'Mapa de asientos',
		selectedPassenger: 'Pasajero seleccionado',
		yourSeatAria: 'Tu asiento, 13A',
		seatAria: 'Asiento {seat}',
		alexSeatAria: 'Asiento {seat}, Alex Mercer',
		you: 'TÚ',
		selectPassenger: 'Selecciona un pasajero',
		clickSeatForData: 'Haz clic en un asiento para ver los datos disponibles.',
		javascriptRequired: 'Esta actividad para el aula necesita JavaScript para abrir el manifiesto de pasajeros.',
		yourFriend: 'Tu amigo',
		seat: 'Asiento',
		hometown: 'Ciudad de origen',
		passport: 'Pasaporte',
		aiLikelySuspectScore: 'Puntaje de probable sospechoso según la IA',
		facialRecognitionConfidence: 'Nivel de confianza del reconocimiento facial',
		sex: 'Sexo',
		age: 'Edad',
		height: 'Estatura',
		eyeColor: 'Color de ojos',
		hairColor: 'Color de cabello',
		digitalFootprint: 'Huella digital',
		emailAddresses: 'Direcciones de correo electrónico',
		noneFound: 'No se encontró ninguno',
		socialMedia: 'Redes sociales',
		recentPurchases: 'Compras recientes',
		noData: 'No hay datos',
		lastThreeTextMessages: 'Últimos 3 mensajes de texto',
		message: 'Mensaje',
		lastThreeWebsitesVisited: 'Últimos 3 sitios web visitados',
		male: 'Masculino',
		female: 'Femenino',
	},
	'tr-TR': {
		metaTitle: 'Uçuş 67',
		metaDescription:
			'Uçuş 67 yolcu manifestosunu inceleyin ve bir yapay zekâ sisteminin yolcu verilerinden neler çıkarabileceğini görün.',
		languageLabel: 'Dil',
		english: 'English',
		spanish: 'Español',
		turkish: 'Türkçe',
		classroomActivity: 'Sınıf etkinliği',
		flight67: 'Uçuş 67',
		passengerManifest: 'Yolcu Manifestosu',
		introParagraph1:
			"Uçuş 67'de arkadaşın Alex'in yanında oturuyorsun. Koltuk haritasından herhangi bir yolcunun dosyasını aç, ardından bir araştırmacının ve bir yapay zekâ modelinin neler öğrenebileceğini görmek için veri kaynaklarını etkinleştir.",
		introParagraph2:
			'Daha fazla veri eklendikçe tablonun nasıl değiştiğini izle. Sistemin “olası şüpheli” puanı her zaman doğru kişiyi mi gösteriyor?',
		instruction1: 'Bir yolcunun dosyasını açmak için koltuğa tıkla.',
		instruction2:
			'Biyometrik verileri, telefon verilerini ve yapay zekâ analizini görüntülemek için veri erişimi düğmelerini kullan.',
		instruction3: "Gördüklerini, Alex'inki de dahil olmak üzere, yapay zekânın şüpheli puanıyla karşılaştır.",
		openManifest: 'Manifestoyu aç',
		manifestTitle: 'Uçuş 67 yolcu manifestosu',
		confidential: 'Gizli',
		backToInstructions: 'Talimatlara dön',
		dataAccess: 'Veri erişimi',
		biometrics: 'Biyometrik veriler',
		on: 'Açık',
		off: 'Kapalı',
		cellPhoneData: 'Cep telefonu verileri',
		digitalProfile: 'Dijital profil',
		websites: 'Web siteleri',
		texts: 'Mesajlar',
		purchases: 'Satın alımlar',
		aiAnalysis: 'Yapay zekâ analizi',
		facialRec: 'Yüz tanıma',
		suspectScore: 'Şüpheli puanı',
		alexMercer: 'Alex Mercer',
		seatMap: 'Koltuk haritası',
		selectedPassenger: 'Seçili yolcu',
		yourSeatAria: 'Koltuğun, 13A',
		seatAria: 'Koltuk {seat}',
		alexSeatAria: 'Koltuk {seat}, Alex Mercer',
		you: 'SEN',
		selectPassenger: 'Bir yolcu seç',
		clickSeatForData: 'Mevcut verileri görüntülemek için bir koltuğa tıkla.',
		javascriptRequired: 'Bu sınıf etkinliğinde yolcu manifestosunu açmak için JavaScript gerekir.',
		yourFriend: 'Arkadaşın',
		seat: 'Koltuk',
		hometown: 'Memleket',
		passport: 'Pasaport',
		aiLikelySuspectScore: 'Yapay zekâ olası şüpheli puanı',
		facialRecognitionConfidence: 'Yüz tanıma güven oranı',
		sex: 'Cinsiyet',
		age: 'Yaş',
		height: 'Boy',
		eyeColor: 'Göz rengi',
		hairColor: 'Saç rengi',
		digitalFootprint: 'Dijital ayak izi',
		emailAddresses: 'E-posta adresleri',
		noneFound: 'Bulunamadı',
		socialMedia: 'Sosyal medya',
		recentPurchases: 'Son satın alımlar',
		noData: 'Veri yok',
		lastThreeTextMessages: 'Son 3 kısa mesaj',
		message: 'Mesaj',
		lastThreeWebsitesVisited: 'Son ziyaret edilen 3 web sitesi',
		male: 'Erkek',
		female: 'Kadın',
	},
}
